/* Inklapbare productbeschrijving met "Toon meer" / "Toon minder" */
if (!customElements.get('read-more-toggle')) {
  customElements.define('read-more-toggle', class ReadMoreToggle extends HTMLElement {
    connectedCallback() {
      this.inner = this.querySelector('.product-description-below__inner');
      this.button = this.querySelector('.product-description-below__btn');
      if (!this.inner || !this.button) return;

      this.collapsed = parseInt(this.getAttribute('data-collapsed-height'), 10) || 220;
      this.style.setProperty('--rm-collapsed-height', this.collapsed + 'px');

      this.button.addEventListener('click', () => this.toggle());

      // Beslis of de knop nodig is zodra de afbeeldingen/lettertypes geladen zijn
      this.evaluate();
      if (document.readyState !== 'complete') {
        window.addEventListener('load', () => this.evaluate(), { once: true });
      }

      // Herbereken bij resize (debounced)
      window.addEventListener('resize', () => this.debouncedEvaluate());

      // Herbereken wanneer een tab wisselt (actieve panel verandert van hoogte)
      this._observer = new MutationObserver(() => this.debouncedEvaluate());
      this._observer.observe(this.inner, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
        childList: true
      });
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }

    debouncedEvaluate() {
      clearTimeout(this._t);
      this._t = setTimeout(() => this.evaluate(), 200);
    }

    evaluate() {
      // Bij uitgeklapt laten we alles staan
      if (this.classList.contains('is-expanded')) return;
      const needs = this.inner.scrollHeight > this.collapsed + 8;
      this.classList.toggle('rm-needs-toggle', needs);
    }

    toggle() {
      const expanded = this.classList.toggle('is-expanded');
      this.button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  });
}
